import { Component, Input } from '@angular/core';
import { InterviewDataService } from './services/interview-data.service';

@Component({
    selector: 'feedback-list',
    templateUrl: './feedback-list.component.html',
    styleUrls: ['./feedback-list.component.css'],
    standalone: false
})
export class FeedbackListComponent {
    @Input() feedbackList = [];
    today = new Date();

    constructor(public _dataService: InterviewDataService) {}

    get hasAiFeedback(): boolean {
        return this.feedbackList.some(f => f.reviewer === 'AI');
    }
}